/**
 *
 * @name categoryModifierChangeShowHide
 * @description - добавляем show/hide в список с категориями
 * @param {array} categories - Список категорий
 * @param {number} id
 * @returns {array}
 */
export const categoryModifierChangeShowHide = (categories, id) => {
  if (categories.length) {
    return categories.map((category) => {
      if (category.id === id) {
        return {
          ...category,
          show: !category.show,
        }
      }
      return category;
    })
  }
  return categories;
}

/**
 *
 * @name categoryModifierFormatted
 * @description Приводим список категорий к нужному виду
 * @param {array} oldCategories
 * @param {array} newCategories
 * @returns {array}
 */
export const categoryModifierFormatted = (newCategories, oldCategories) => newCategories.map((category, startListCategoryIndex) => {
  const findOldCategory = oldCategories ? oldCategories.find((item) => item.id === category.id) : false;
  return {
    ...category,
    show: findOldCategory ? findOldCategory.show : true,
    services: category.hasOwnProperty('services') ? category.services.map((service) => ({
      ...service,
      startListCategoryIndex,
    })) : [],
  }
});
